import React from 'react';
import { useHistory } from 'react-router';
import { useShopStore } from '../../../redux/shop/facade';
import { useStorefrontBranding } from '../../../redux/branding/facade';
import { StorefrontCartComponent } from '../components/storefront-cart.component';

export const StorefrontCartContainer: React.FC = () => {
    const history = useHistory();
    const { cart, cartTotal, updateCartItem, removeFromCart, clearCart } = useShopStore();
    const { currencyPrefix } = useStorefrontBranding();

    const handleUpdateQuantity = (id: string, quantity: number) => {
        if (quantity <= 0) {
            removeFromCart(id);
        } else {
            updateCartItem(id, quantity);
        }
    };

    const handleRemoveItem = (id: string) => {
        removeFromCart(id);
    };

    const handleClearCart = () => {
        clearCart();
    };

    const handleProceed = () => {
        history.push('/shop/checkout');
    };

    return (
        <StorefrontCartComponent
            cart={cart}
            cartTotal={cartTotal}
            currencyPrefix={currencyPrefix}
            onUpdateQuantity={handleUpdateQuantity}
            onRemoveItem={handleRemoveItem}
            onClearCart={handleClearCart}
            onProceed={handleProceed}
        />
    );
};

export default StorefrontCartContainer;
